import { Route } from 'src/routes/Route'

export const ActErrorRoute = Route({
  path: '/error/:code',
  init: (code: string) => ({ code }),
  fromPath: ({ code }) => (code ? { code } : undefined),
})
export type ActErrorRoute = Route<typeof ActErrorRoute>
